import { LOCALE_ID, Provider } from '@angular/core';
import { AppLocaleService } from '../services/locale.service';

export class AppLocaleId extends String {
  constructor(private localeService: AppLocaleService) {
    super();
  }

  override toString(): string {
    return this.localeService.locale;
  }

  override valueOf(): string {
    return this.toString();
  }
}

/** Provider custom per il locale, realizzato per permettere il cambio del locale senza forzare il reload dell'applicazione Ref: https://angular-dynamic-locale-4ld5c2jq.stackblitz.io */
export const AppLocaleProvider: Provider = {
  provide: LOCALE_ID,
  useClass: AppLocaleId,
  deps: [AppLocaleService],
};
